'use client';
import Skeleton from '../../../components/Skeleton';
import TileData from '../../../components/TileData';
import { CompanyLabels } from '../../lib/labels';

import Info from './info';
import Interests from './interests';

import { useUserStore } from '@utils/user';
import { User } from 'types/user';

interface Props {
  labels: CompanyLabels;
  user: User | null;
}

export default function Company({ labels, user }: Props) {
  const userStore = useUserStore();

  if (!userStore.isReady || !user) {
    return <Skeleton className="col-span-2" title={labels.title} numinputs={4} />;
  }
  return (
    <TileData title={labels.title} className="lg:col-span-2">
      <Interests labels={labels} user={user} />
      <Info labels={labels} user={user} />
    </TileData>
  );
}

export type { Props as CompanyProps };
